/* eslint-disable no-use-before-define */
/* eslint-disable import/no-named-default */
import React from 'react'
import { default as lodash } from 'lodash'
import { formatToCNPJ, formatToCPF, isCNPJ, isCPF } from 'brazilian-values'
import { formatInBrazilianDate, isDate } from 'utils/functions'
import { PROCESS_TYPES_MESSAGES } from 'utils/constants/types'

import { Alert } from '@mui/material'
import { correctServiceName } from 'utils/constants/correctedServiceNames'
import { infos } from './fieldsInfo'
import styles from './styles'

const ProcessRow = (props) => {
  const { processData } = props
  const classes = styles()

  const renderProcessContent = (info, fieldVal) => {
    return <div style={{ marginLeft: 10 }}>{renderField(info, fieldVal)}</div>
  }

  const formatContent = (content) => {
    if (isDate(content)) return formatInBrazilianDate(content)

    if (isCPF(content)) return formatToCPF(content)
    if (isCNPJ(content)) return formatToCNPJ(content)
    return content
  }

  const renderField = (item, fieldVal) => {
    const content = item

    if (lodash.isString(content) || lodash.isBoolean(content)) {
      return (
        <React.Fragment>
          <strong>{fieldVal}</strong>
          {': '}
          {lodash.isString(content)
            ? formatContent(content)
            : content
            ? 'Sim'
            : 'Não'}
        </React.Fragment>
      )
    }

    return null
  }

  const renderOtherInfos = (process) => {
    if (
      lodash
        .chain(process?.data)
        .pick(lodash.keys(lodash.get(infos.options, 'fields')))
        .every(lodash.isEmpty)
        .value()
    ) {
      return null
    }

    return (
      <React.Fragment>
        {lodash
          .map(infos.options.fields, (fieldVal, fieldKey) => {
            const info = lodash.get(process?.data, fieldKey)
            return info ? (
              <React.Fragment key={fieldKey}>
                {renderProcessContent(info, fieldVal, fieldKey)}
              </React.Fragment>
            ) : null
          })
          .filter((item) => item !== null)}
      </React.Fragment>
    )
  }

  return (
    <div>
      <span className={classes.title}>{correctServiceName(processData.court_description)}</span>

      {processData?.risk_of_homonymy && (
          <div className={classes.alertDiv}>
          <Alert severity='error' variant='outlined'>
            O sistema deste tribunal estava indisponível no momento da consulta
            e as informações a seguir foram obtidas mediante pesquisa por nome
            feita ao Diário da Justiça. Por este motivo, o resultado pode conter
            homônimos.
          </Alert>
          </div>
        )}  

      <div className={classes.processHeadInfo}>
        {processData?.data?.cpf && (
          <React.Fragment>
            <span>
              <b>CPF: </b>
              {formatToCPF(processData?.data?.cpf)}
            </span>
            {processData?.data?.envolved_kind && (
              <span>
                <b>Tipo Envolvido: </b>
                {processData?.data?.envolved_kind === 'POLE_PASSIVE'
                  ? 'Polo Passivo'
                  : ''}
              </span>
            )}
          </React.Fragment>
        )}
        {processData?.has_number && (
          <span>
            <b>Número do processo: </b>
            {processData?.number}
          </span>
        )}
        {processData?.subject && (
          <span>
            <b>Assunto: </b>
            {processData?.subject}
          </span>
        )}
        {processData?.type && (
          <span>
            <b>Tipo do processo: </b>
            {PROCESS_TYPES_MESSAGES[processData?.type]?.replace(/\b[a-z]/g, match => match.toUpperCase())}
          </span>
        )}

        <span>
          <b>Contém palavras chave de risco: </b>
          {processData?.contains_risk_keyword ? 'Sim' : 'Não'}
        </span>

        <span>
          <b>É pendencia financeira: </b>
          {processData?.is_financial_penalty ? 'Sim' : 'Não'}
        </span>
      </div>
      <div className={classes.processHeadInfo}>
        <span>Dados do processo:</span>
        {renderOtherInfos(processData)}
      </div>
    </div>
  )
}

export default ProcessRow
